module.exports = __webpack_public_path__ + "img/check-off.02151386.svg";